import { combineReducers } from "redux";
import { hotelInfoReducer } from "./hotelInfo";
import { currencyReducer } from "./currency";

export const rootReducer = combineReducers({
  hotelInfo: hotelInfoReducer,
  currency: currencyReducer,
});
